const idsFluxosProcessos = {
    analiseCredito:  "SOLICITACAO_ANALISE_CREDITO",
    solicitRessuprimento: "SOLICITACAO_RESSUPRIMENTO",
    cancelarRecibo: "SOLICITACAO_CANCELAMENTO_RECIBO",
    criacaoTituloPagar: "SOLICITACAO_CRIACAO_TITULO_PAGAR",
    criacaoApGlobal: "SOLICITACAO_CRIACAO_AP_GLOBAL",
    criacaoCooperado: "SOLICITACAO_CRIACAO_COOPERADO",
}

export default idsFluxosProcessos